import * as React from "react";
import { useState, useEffect } from "react";
import logo from "../../assets/spero_logo_new.png";
import "./Login.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import user from "../../assets/user.png";
import key from "../../assets/key.png";
import { useAuth } from "../Context/ContextAPI";
import { port } from "../../../../src/config";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URL } from "../Config/api";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import { useCall } from "../Context/CallContext";

export default function Loginextentions() {
  const { handleAuth } = useAuth();
  const { connectSocket } = useCall();
  const [login, setLogin] = useState({
    clg_ref_id: "",
    password: "",
    extensions: "",
  });
  const [extensionsList, setExtensionsList] = useState([]);
  const [extensionError, setExtensionError] = useState(false);
  const [userIdError, setUserIdError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showExistErrorAlert, setShowExistErrorAlert] = useState(false);
  const [showExistErrorAlert1, setShowExistErrorAlert1] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showExtAlert, setShowExtAlert] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [showExtReqMsg, setShowExtReqMsg] = useState(false);
  const [isHdUser, setIsHdUser] = useState(false);
  const [showExtRequiredAlert, setShowExtRequiredAlert] = useState(false);
  const [showHdOnlyAlert, setShowHdOnlyAlert] = useState(false);
  const [showSelect1111Alert, setShowSelect1111Alert] = useState(false);

  const [showTimeoutAlert, setShowTimeoutAlert] = useState(false);
  const [showNetworkDownAlert, setShowNetworkDownAlert] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchExtensions = async () => {
      try {
        const response = await fetch(`${API_URL}/web/get_extensions/`);
        const data = await response.json();
        setExtensionsList(data);
      } catch (error) {
        console.error("Error fetching extensions:", error);
      }
    };
    fetchExtensions();
  }, []);

  const handleChange = async (e) => {
    e.preventDefault();

    setUserIdError(login.clg_ref_id === "");
    setPasswordError(login.password === "");

    if (login.clg_ref_id === "" || login.password === "") {
      return;
    }

    if (isHdUser && login.extensions === "") {
      setExtensionError(true);
      return;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      setLoading(true);

      // --- UPDATED: Extension chahe jo bhi ho, hamesha API_URL hi use hoga ---
      const targetApiUrl = API_URL;

      const response = await fetch(`${targetApiUrl}/web/login/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          clg_ref_id: login.clg_ref_id,
          password: login.password,
          extension_no: login.extensions || "",
          is_cloud: "True",
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      // Handle server side errors
      if (response.status >= 500) {
        setShowSelect1111Alert(true);
        setTimeout(() => setShowSelect1111Alert(false), 5000);
        setLoading(false);
        return;
      }

      if (response.status === 401) {
        setShowExistErrorAlert1(true);
        setTimeout(() => setShowExistErrorAlert1(false), 3000);
      } else if (response.status === 404) {
        setShowErrorAlert(true);
        setTimeout(() => setShowErrorAlert(false), 3000);
      } else {
        setShowErrorAlert(false);
        const data = await response.json();

        if (data.msg === "Extension login allowed only for HD users") {
          setShowHdOnlyAlert(true);
          setTimeout(() => setShowHdOnlyAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension is required for HD users") {
          setIsHdUser(true);
          setShowExtRequiredAlert(true);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension already logged in with another user") {
          setShowExtAlert(true);
          setTimeout(() => setShowExtAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.token?.user_group === "hd" && !login.extensions) {
          setIsHdUser(true);
          setShowExtRequiredAlert(true);
          setLoading(false);
          return;
        }

        if (data.msg === "User Already Logged In. Please check.") {
          setShowExistErrorAlert(true);
          setTimeout(() => setShowExistErrorAlert(false), 3000);
        } else {
          setSuccessAlert(true);
          localStorage.setItem("selected_extension", login.extensions);
          localStorage.setItem("token", data.token.access);
          localStorage.setItem("refresh", data.token.refresh);
          localStorage.setItem(
            "user-image",
            data.token.colleague.profile_photo_path,
          );
          localStorage.setItem("user-name", data.token.colleague.first_name);
          localStorage.setItem("user-lname", data.token.colleague.last_name);
          localStorage.setItem("user-email", data.token.colleague.email);
          localStorage.setItem("user-phone", data.token.colleague.phone_no);
          localStorage.setItem("user-loc", data.token.colleague.address);
          localStorage.setItem(
            "user-designation",
            data.token.colleague.designation,
          );
          localStorage.setItem("clg_id", data.token.colleague.id);
          localStorage.setItem("hospitalId", data.token.colleague.clg_hosp_id);
          localStorage.setItem("clgrefId", data.token.colleague.clg_ref_id);
          localStorage.setItem("user_group", data.token.user_group);
          localStorage.setItem(
            "permissions",
            JSON.stringify(data.token.permissions),
          );
          localStorage.setItem("companyID", data.token.colleague.prof_compny);

          if (data.token.user_group === "hd" && login.extensions) {
            connectSocket(login.extensions);
          }

          setTimeout(() => {
            const group = data.token.user_group;
            if (group === "hd") {
              navigate("/dashboard");
              handleAuth();
              window.location.reload();
            } else if (group === "HR") navigate("/hr/manage profiles");
            else if (group === "M_DASH") navigate("/MM2Dashboard");
            else if (group === "HR Partner")
              navigate("/hr partner/manage professionals");
            else if (group === "ADMIN") navigate("/hhc/dashboard");
            else if (group === "ACCOUNT") navigate("/hhc/account/dashboard");
            else if (group === "REPORTS") navigate("/reports/dashboard");
            else if (group === "HOSPITAL") navigate("/hospital/dashboard");
            else if (group === "ATTENDANCE")
              navigate("/attendance/attendance-view");
            else if (group === "MANAGEMENT")
              navigate("/management/management-dashboard");
            else if (group === "clincal_gov") navigate("/hhc/clinical/closure");
            else if (group === "HHC_Analytics") navigate("/analytics/home");
            else if (group === "physio") navigate("/physio");
            else if (group === "physioMilestone") navigate("/physioMilestone");
            else if (group === "Consultant")
              navigate("/hhc/consultant/referred patient details");
          }, 2000);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        setShowTimeoutAlert(true);
        setTimeout(() => setShowTimeoutAlert(false), 5000);
      } else if (
        error.message.includes("Failed to fetch") ||
        error.message.includes("NetworkError")
      ) {
        setShowNetworkDownAlert(true);
        setTimeout(() => setShowNetworkDownAlert(false), 5000);
      } else {
        console.error("Error during API call:", error);
      }
    } finally {
      clearTimeout(timeoutId);
      setLoading(false);
    }
  };

  const onchange = (e) => {
    const { name, value } = e.target;
    setLogin((prevLogin) => ({ ...prevLogin, [name]: value }));
    if (name === "clg_ref_id") setUserIdError(false);
    if (name === "password") setPasswordError(false);
    if (name === "extensions") setExtensionError(false);
  };

  return (
    <>
      <div className="container">
        <div className="input_fields">
          {!isSmallScreen && (
            <img
              src={logo}
              alt="Logo"
              style={{ height: "110px", width: "160px", borderRadius: "8px" }}
            />
          )}

          {showTimeoutAlert && (
            <Alert
              severity="warning"
              variant="filled"
              sx={{ mt: 2, borderRadius: "8px" }}
            >
              Request timed out. Please try again.
            </Alert>
          )}

          {showNetworkDownAlert && (
            <Alert
              severity="error"
              variant="filled"
              sx={{ mt: 2, borderRadius: "8px" }}
            >
              Unable to connect to the server.
            </Alert>
          )}

          {showSelect1111Alert && (
            <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
              This extension is temporarily unavailable.
            </Alert>
          )}

          {successAlert && (
            <Alert severity="success" variant="filled">
              Login Successful! Redirecting...
            </Alert>
          )}
          {showErrorAlert && (
            <Alert severity="error" variant="filled">
              Invalid User ID or Password!
            </Alert>
          )}
          {showExistErrorAlert && (
            <Alert severity="error" variant="filled">
              User is already logged in!
            </Alert>
          )}
          {showExistErrorAlert1 && (
            <Alert severity="error" variant="filled">
              Login Access Denied!
            </Alert>
          )}
          {showExtAlert && (
            <Alert severity="warning" variant="filled">
              Extension already logged in!
            </Alert>
          )}
          {showHdOnlyAlert && (
            <Alert
              severity="info"
              variant="filled"
              sx={{ mt: 2, borderRadius: "8px" }}
            >
              Extension login allowed only for HD users.
            </Alert>
          )}

          <Box
            component="form"
            sx={{
              mt: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "6px",
              border: "1px solid #000",
            }}
          >
            <img
              src={user}
              alt=""
              style={{ height: "18px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Enter User ID"
              name="clg_ref_id"
              autoComplete="off"
              onChange={onchange}
              required
              error={userIdError}
            />
          </Box>
          {userIdError && (
            <Typography variant="body2" color="error">
              User ID is required*
            </Typography>
          )}

          <Box
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "6px",
              border: "1px solid #000",
            }}
          >
            <img
              src={key}
              alt=""
              style={{ height: "20px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 1.2, flex: 1 }}
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              name="password"
              onChange={onchange}
              required
              error={passwordError}
            />
            <Button
              onClick={() => setShowPassword(!showPassword)}
              size="small"
              startIcon={showPassword ? <VisibilityOff /> : <Visibility />}
            />
          </Box>
          {passwordError && (
            <Typography variant="body2" color="error">
              Password is required*
            </Typography>
          )}

          <Box
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "6px",
              border: "1px solid #000",
            }}
          >
            <PhoneForwardedIcon
              sx={{ fontSize: "18px", ml: 1, color: "black" }}
            />
            <Select
              displayEmpty
              name="extensions"
              value={login.extensions}
              onChange={onchange}
              sx={{
                ml: 1,
                flex: 1,
                height: "100%",
                ".MuiOutlinedInput-notchedOutline": { border: 0 },
              }}
            >
              <MenuItem value="" disabled>
                Select Extension
              </MenuItem>
              {extensionsList.map((ext) => (
                <MenuItem key={ext.extension_id} value={ext.extensions}>
                  {ext.extensions}
                </MenuItem>
              ))}
            </Select>
          </Box>
          {extensionError && (
            <Typography variant="body2" color="error">
              Extension Number is required*
            </Typography>
          )}

          <Button
            variant="contained"
            sx={{
              mt: 6,
              width: "28ch",
              height: "7vh",
              backgroundColor: "#69DAC3",
              borderRadius: "6px",
              color: "black",
            }}
            onClick={handleChange}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>

          {isSmallScreen && (
            <img
              src={logo}
              alt="Logo"
              style={{ height: "70px", width: "120px" }}
            />
          )}

          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {[
                { label: "Privacy & Policy", path: "/termsandconditions" },
                {
                  label: "Refund & Cancellation",
                  path: "/CancellationRefundPolicy",
                },
                { label: "Contact Us", path: "/ContactInfo" },
                { label: "About Us", path: "/About-Us" },
              ].map((item, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    color: "#444",
                    fontWeight: 500,
                    cursor: "pointer",
                    "&:hover": { color: "#0072BC" },
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>
            <Box
              sx={{
                width: 120,
                height: 3,
                borderRadius: 2,
                background: "linear-gradient(90deg, #69DAC3, #3DDAD7)",
                mt: 2,
              }}
            />
          </Box>
        </div>
      </div>
    </>
  );
}
